<ngx-loading [show]="loading"></ngx-loading>
<div #workflowContainer class="workflow-container">
  <!-- Details Block -->
  <div class="container-fluid jumbotron-fluid border-bottom mb-4"
    style="min-width: 500px;">
    <div class="row align-items-center">

      <div class="col-xs-12 col-md-auto text-right order-md-2 mb-2 mb-md-0">
        <a class="go-back text-right btn btn-link" (click)="location.back()">
          <i class="fa fa-caret-left pr-1"></i>
          Go back
        </a>
      </div>

      <div class="col">
        <div class="row">
          <div class="col-auto">
            <strong>Workflow:</strong>
            <span>{{ workflow?.name }}</span>
          </div>
          <div class="col-auto">
            <strong>Description:</strong>
            <span>{{ workflow?.description }}</span>
          </div>
          <div class="col-auto">
            <strong>Enabled:</strong>
            <span>{{ workflow?.is_enabled ? 'Yes' : 'No' }}</span>
          </div>
          <div class="col-auto">
            <button class="btn btn-link" (click)="openEditWorkflowModal()">
              <i class="fa fa-edit"></i>
              Edit
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ngx-timeline
    *ngIf="!!workflow"
    [workflowDefinition]="workflow"
    class="timeline-container-wrapper"
   >
  </ngx-timeline>

</div>